
import { computed, ref } from 'vue'
import RenameModal from './RenameModal.vue'
import { message, Modal } from 'ant-design-vue'
import * as service from '../service'
import { downLoadFromOss } from '@/utils/oss'
import { shareModeEnum } from '@/utils/dataMap'
import {
  STAT_EVENT,
  mineCoursewareStatResport
} from '@/utils/common/statReport'
import CardNameTitle from './CardNameTitle.vue'

export default {
  components: { RenameModal, CardNameTitle },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    },
    look: {
      type: Boolean,
      default: () => false
    }
  },
  setup(props, { emit }) {
    const coursewareInfo = computed(() => props.value)
    const coursewareLook = computed(() => props.look)
    const coursewareName = ref(coursewareInfo.value.name || '')
    const fileInfo = ref(coursewareInfo.value.courseware)

    const previewVisible = ref(false)

    const renameVisible = ref(false)

    const loading = ref(false)

    const handlePreview = () => {
      previewVisible.value = true
    }

    const handleCancelPreview = () => { previewVisible.value = false }

    const handleDownload = () => {
      downLoadFromOss(fileInfo.value.url, fileInfo.value.name)
    }

    const handleRename = () => {
      renameVisible.value = true
    }

    const handleRenameCancel = () => {
      renameVisible.value = false
    }

    const handleRenameOk = async (name) => {
      try {
        loading.value = true
        const params = {
          name
        }
        await service.renameCourseware(fileInfo.value.id, params)
        loading.value = false
        message.success('修改成功')
        handleRenameCancel()
        emit('refresh')
      } catch (error) {
        console.log(error)
        loading.value = false
      }
    }

    const handleDelete = async () => {
      try {
        emit('showLoading', true)
        await service.deleteTeacherCourseware(fileInfo.value.id)
        mineCoursewareStatResport(STAT_EVENT.PREPARE_LESSON_MINECOURSEWARES_DELETE, {
          courseware_id: fileInfo.value.id,
          courseware_type: fileInfo.value.type
        })
        message.success('删除成功')
        emit('refresh')
        emit('showLoading', false)
        emit('refresh')
      } catch (error) {
        console.log(error)
        emit('showLoading', false)
      }
    }

    const showDeleteWarning = () => {
      Modal.confirm({
        title: '警告',
        content: '是否确认删除该文件？删除后将不可恢复',
        closable: true,
        onOk: handleDelete,
        onCancel: () => {
          Modal.destroyAll()
        }
      })
    }

    const handleMove = () => {
      emit('onMove', coursewareInfo.value)
    }

    // 分享课件
    const handleShare = () => {
      emit('onShare', coursewareInfo.value)
    }

    return {
      coursewareInfo,
      coursewareName,
      previewVisible,
      fileInfo,
      renameVisible,
      loading,
      shareModeEnum,
      handlePreview,
      handleCancelPreview,
      handleDownload,
      handleRename,
      handleRenameCancel,
      handleRenameOk,
      handleDelete,
      showDeleteWarning,
      handleMove,
      handleShare,
      coursewareLook
    }
  }

}
